import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=48477f87&"
import script from "./radio.vue?vue&type=script&lang=js&"
export * from "./radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48477f87')) {
      api.createRecord('48477f87', component.options)
    } else {
      api.reload('48477f87', component.options)
    }
    module.hot.accept("./radio.vue?vue&type=template&id=48477f87&", function () {
      api.rerender('48477f87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/radio/radio.vue"
export default component.exports